/**
 * Langues gérées par le produit — le français, plus les langues parlées aux frontières
 * de la France (Allemagne/Suisse/Belgique/Luxembourg, Espagne, Italie/Suisse, Belgique),
 * et l'anglais comme repli international.
 *
 * Une famille séparée n'est pas toujours mono-nationale ; c'est justement le public de
 * Repère. La liste grandira, mais chaque langue ajoutée demande un catalogue tenu par
 * quelqu'un qui la parle — mieux vaut six langues correctes que vingt approximatives.
 */
export const LOCALES = ['fr', 'en', 'de', 'es', 'it', 'nl'];
/** Le français : c'est la langue dans laquelle le produit est écrit et pensé. */
export const LOCALE_PAR_DEFAUT = 'fr';
/**
 * Repli quand la détection échoue — délibérément différent de `LOCALE_PAR_DEFAUT`.
 *
 * Le français est la langue du produit, mais ce n'est la langue *de la personne* que si
 * elle l'a déclarée ou choisie. Rebasculer en français quelqu'un dont le navigateur ne
 * déclare aucune des six langues gérées, ce serait remplacer une inconnue par une autre
 * hypothèse tout aussi arbitraire. L'anglais est le repli le plus souvent compris dans ce
 * cas — pas une affirmation que la personne le lit couramment, juste le moins mauvais pari.
 */
const LOCALE_REPLI_DETECTION = 'en';
export function estLocaleGeree(valeur) {
    return LOCALES.includes(valeur);
}
/**
 * Nom d'une langue, dans la langue d'affichage — via `Intl.DisplayNames`, comme les noms
 * de pays de `residence/countries.ts`. Même raisonnement : aucune table à traduire six
 * fois et à tenir à jour, la plateforme le sait déjà.
 */
export function nomDeLaLangue(locale, dansLaLangue) {
    return new Intl.DisplayNames([dansLaLangue, 'fr'], { type: 'language' }).of(locale) ?? locale;
}
/**
 * Langue par défaut, déduite des langues déclarées par le navigateur.
 *
 * `candidats` reçoit `navigator.languages` tel quel (ou un tableau de test) : chaque
 * entrée est une étiquette BCP 47 (`fr-FR`, `en-US`…), dont seuls les deux premiers
 * caractères comptent ici — le produit ne distingue pas les variantes régionales d'une
 * langue, comme pour les pays. La première langue déclarée qui est gérée l'emporte.
 *
 * Aucune géolocalisation IP : le navigateur est la seule source, et quand aucune de ses
 * langues déclarées n'est gérée, le repli est `LOCALE_REPLI_DETECTION` (anglais), pas le
 * français du produit — voir sa documentation.
 */
export function detecterLocaleNavigateur(candidats) {
    for (const candidat of candidats) {
        const court = candidat.slice(0, 2).toLowerCase();
        if (estLocaleGeree(court))
            return court;
    }
    return LOCALE_REPLI_DETECTION;
}
//# sourceMappingURL=locales.js.map